import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styled from "styled-components/macro";

import {
  faBell,
  faExclamationCircle,
} from "@fortawesome/pro-regular-svg-icons";
import { motion } from "framer-motion";

import Uno from "UI/images/Uno";

const icon = {
  info: faBell,
  warning: faExclamationCircle,
  sos: faExclamationCircle,
};

/**
 * @param {messageObj: {alertLevel: "info" | "warning" | "sos", message: string}} props
 */
export default function CrisisSystemMessage({ messageObj }) {
  const { message, alertLevel } = messageObj;

  return (
    <Wrapper messageType={alertLevel}>
      <motion.div
        style={{
          originX: 0.5,
          // originY: level !== "info" ? 0.5 : 0,
          display: "flex",
          justifyContent: "flex-start",
          alignContent: "center",
        }}
        animate={{
          rotate: [0, 10, -10, 10, -10, 10, -10, 10, -10, 0],
          transition: {
            delay: 0.4,
          },
        }}
      >
        {alertLevel !== "info" ? (
          <FontAwesomeIcon icon={icon[alertLevel]} size="2x" />
        ) : (
          <Uno color="blue" />
        )}
      </motion.div>
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </Wrapper>
  );
}

const BGColor = {
  info: "var(--gray)",
  warning: "var(--yellow)",
  sos: "var(--red)",
};

const Wrapper = styled.div`
  --red: linear-gradient(145deg, #b4252dcc, #b4252d);
  --yellow: linear-gradient(145deg, #fccf6bcc, #fccf6b);
  --gray: linear-gradient(145deg, #d9d9d9cc, #d9d9d9);
  display: grid;
  grid-template-columns: 32px 1fr;
  align-items: center;
  gap: 14px;
  background: ${(props) => BGColor[props.messageType]};
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 20px;
  box-shadow: 0 0 6px rgb(0 0 0 / 8%);
  color: ${(props) => (props.messageType === "sos" ? "white" : "inherit")};
  box-shadow: 1px 2px 6px rgb(0 0 0 / 30%);
`;
